import { CustomComponent } from './CustomComponent.model';
import { CustomModalDTO } from '../dto/modal/customModal.dto';

export class CustomModal {
  uuid: string;
  name: string;
  customComponents: CustomComponent[];
  settings: { [key: string]: { mode?: 1 | 2 | 3, type: string, value: any } };
  
  constructor(
    name: string, 
    customComponents: CustomComponent[] = [],
    settings: { [key: string]: { mode?: 1 | 2 | 3, type: string, value: any } } = {},
    uuid: string = crypto.randomUUID()
  ) {
    this.uuid = uuid;
    this.name = name;
    this.customComponents = customComponents;
    this.settings = settings;

    if (!this.settings['customID'] || !this.settings['customID'].value || this.settings['customID'].value.trim() === '') {
      this.settings['customID'] = { type: 'string', value: `${name}_${this.uuid}_parent` };
    }
    
    if (!this.settings['customClasses'] || !this.settings['customClasses'].value || this.settings['customClasses'].value.trim() === '') {
      this.settings['customClasses'] = { type: 'string', value: "" };
    }

    if (!this.settings['customCSS']) {
        this.settings['customCSS'] = { type: 'string', value: {} };
    }

    // Set default customCSS for each mode if not present
    [1, 2, 3].forEach(mode => {
        if (!this.settings['customCSS'].value[mode]) {
            this.settings['customCSS'].value[mode] = '';
        }
    });

    if (!this.settings['width']) {
        this.settings['width'] = { type: 'string', value: {} };
    }

    const defaultWidths: Record<1 | 2 | 3, string> = {
        1: '80vw', 
        2: '90vw', 
        3: '95vw'
    };

    // Set default widths for each mode if not present
    ([1, 2, 3] as const).forEach((mode) => {
        if (!this.settings['width'].value[mode]) {
            this.settings['width'].value[mode] = defaultWidths[mode];
        }
    });

    if (!this.settings['height']) {
        this.settings['height'] = { type: 'string', value: {} };
    }

    const defaultHeights: Record<1 | 2 | 3, string> = {
        1: '90vh',
        2: '95vh',
        3: '95vh'
    };

    // Set default heights for each mode if not present
    ([1, 2, 3] as const).forEach((mode) => {
        if (!this.settings['height'].value[mode]) {
            this.settings['height'].value[mode] = defaultHeights[mode];
        }
    });
  }

  getComponentsForMode(mode: 1 | 2 | 3): CustomComponent[] {
    return this.customComponents.filter(comp => comp.mode === mode);
  }

  public static convertToDTO(modal: CustomModal): CustomModalDTO {
    return {
      uuid: modal.uuid,
      name: modal.name,
      customComponents: modal.customComponents.map(comp => CustomComponent.convertToDTO(comp)),
      settings: modal.settings
    };
  }

  public static fromDTO(dto: CustomModalDTO): CustomModal {
    return new CustomModal(
      dto.name,
      dto.customComponents ? dto.customComponents.map(compDTO => CustomComponent.fromDTO(compDTO)) : [],
      dto.settings,
      dto.uuid
    );
  }
}
